import { Box, Grid, Skeleton } from '@mui/material';

export const ScholarshipCardSkeleton: React.FC = () => {
  return (
    <Box sx={{ bgcolor: 'grey.50', borderRadius: '0.5rem', overflow: 'hidden' }}>
      <Skeleton variant="rectangular" sx={{ borderRadius: 0 }} height="15rem" width="100%" />
      <Box sx={{ p: 3 }}>
        <Skeleton width="10rem" />
        <Skeleton variant="rectangular" height="1.5rem" width="15rem" />
        <Box sx={{ mt: 3 }}>
          <Grid container spacing={1.5} direction="column">
            <Grid item>
              <Skeleton variant="rectangular" width="100%" height="1rem" />
            </Grid>
            <Grid item>
              <Skeleton sx={{ mb: 0.5 }} variant="rectangular" width="40%" height="1rem" />
              <Skeleton variant="rectangular" width="100%" />
            </Grid>
          </Grid>
        </Box>
        <Box sx={{ mt: 4 }}>
          <Grid container spacing={1} alignItems="center" justifyContent="space-between">
            <Grid item>
              <Skeleton variant="rectangular" height="3rem" width="7.5rem" />
            </Grid>
            <Grid item>
              <Skeleton variant="rectangular" height="1.5rem" width="5rem" />
            </Grid>
          </Grid>
        </Box>
        <Box sx={{ mt: 2.5 }}>
          <Skeleton width="10rem" />
        </Box>
      </Box>
    </Box>
  );
};
